export default __webpack_public_path__ + "static/media/nic-logo.bdb25902.svg";